import { isAxiosError } from "axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useGeneralAppStore } from "../store/generalAppStore";
import { useMonitoreoPersonalStore } from "../store/monitoreoPersonal";
import { axios } from "../utils/axios";

const useMonitoreoPersonal = () => {
  const { handlerLoading, handlerModal } = useGeneralAppStore();

  const { setEstadisticasGeneral, setEstadisticasPersona, setPersonalMonitoreo } =
    useMonitoreoPersonalStore();

  const getPersonalMonitoreo = async () => {
    handlerLoading({ loading: true, loadName: "personal-monitoreo" });
    const response = await axios().get("/personal_monitoreo");
    // console.log(response.data);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setPersonalMonitoreo(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "personal-monitoreo" });
  };

  const getEstadisticasPersona = async (values) => {
    handlerLoading({ loading: true, loadName: "interacciones-usuario" });
    const response = await axios().post("interacciones_usuario", values);
    if (!isAxiosError(response)) {
      // console.log(response.data);
      const { data, error } = response.data;
      if (data && !error) {
        setEstadisticasPersona(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "interacciones-usuario" });
  };

  const getEstadisticasGeneral = async (values, signal) => {
    handlerLoading({ loading: true, loadName: "interacciones-personal-monitoreo" });
    const response = await axios().post("interacciones_personal_monitoreo", values, { signal });
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setEstadisticasGeneral(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "interacciones-personal-monitoreo" });
  };

  return {
    getPersonalMonitoreo,
    getEstadisticasPersona,
    getEstadisticasGeneral,
  };
};

export default useMonitoreoPersonal;
